import * as Sentry from "@sentry/react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import { useEffect } from "react";

const DSN = import.meta.env.VITE_SENTRY_DSN || "https://d813b347011a177d5975cc624bafc571@o4511173640716288.ingest.de.sentry.io/4511173654806608";

export function initSentry() {
  if (!DSN) {
    console.info("[Sentry] No DSN configured – skipping init");
    return;
  }
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
